import styled from "styled-components";

import { LuPencilLine } from "react-icons/lu";
import ContainerInfo from "./ContainerInfo";

import { formatValorMoney } from '../../Funcoes/FormatValorMoney/';
import { formatarData } from "../../Funcoes/FormatarData";
import { useModal } from "../../contexts/ModalContext";
import ModalEditInfo from "./ModalEditInfo";

const Container = styled.div`
    width: 100%;
    background-color: #EBEBEB;
    border-radius: 15px;
    box-sizing: border-box;
    overflow: hidden;
`
const Cabecalho = styled.div`
    width: 100%;
    height: 50px;
    background-color: #dbdbdb;
    box-sizing: border-box;
    display: flex;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
`

const Titulo = styled.h2`
    margin: 0;
    font-size: 14px;
    font-weight: bold;
`
const EditBtn = styled.div`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    box-sizing: border-box;
    border: 1px solid #000;
    display: flex;
    & svg{
        width: 15px;
        height: 15px;
        color: #000;
        margin: auto;
    }
    cursor: pointer;
`
const Corpo = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
`

const FormularioDados = ({ data, fetchData }) => {

    const { openModal, isModalOpen } = useModal();

    const abrirEditInfo = () => {
        openModal('editColabInfo')
    }

    return(
        <>
            <Container>
                <Cabecalho>
                    <Titulo>INFORMAÇÕES DO COLABORADOR</Titulo>
                    <EditBtn onClick={ abrirEditInfo } >
                        <LuPencilLine/>
                    </EditBtn>
                </Cabecalho>
                <Corpo>
                    <ContainerInfo title="CRACHÁ DE ACESSO" value={ data?.cracha || '-' } />
                    <ContainerInfo title="CONTRATO" value={ data?.contrato || '-' } />
                    <ContainerInfo title="DISCIPLINA" value={ data?.disciplina || '-' } />
                    <ContainerInfo title="ENCARREGADO" value={ data?.nome_enc || '-' } />
                    <ContainerInfo title="SUPERVISOR" value={ data?.nome_sup || '-' } />
                    <ContainerInfo title="SUPERVISOR GERAL" value={ data?.nome_geral || '-' } />
                    <ContainerInfo title="HOSPEDAGEM" value={ data?.hospedagem || '-' } />
                    <ContainerInfo title="EMPRESTADO" value={ data?.locado || '-' } />
                    <ContainerInfo title="VALOR CARTÃO V.A" value={ "R$ " + ( data?.valor_cartao_va ? formatValorMoney( data.valor_cartao_va ) : formatValorMoney( "0.00" ) ) } />
                    <ContainerInfo title="VALOR MORADIA" value={ "R$ " + ( data?.valor_moradia ? formatValorMoney( data.valor_moradia ) : formatValorMoney( "0.00" ) ) } />
                    <ContainerInfo title="INÍCIO FOLGA CAMPO" value={ data?.inicio_folga ? formatarData( data.inicio_folga ) : '-' } />
                    <ContainerInfo title="FIM FOLGA CAMPO" value={ data?.fim_folga ? formatarData( data.fim_folga ) : '-' } />
                </Corpo>
            </Container>
            {
                isModalOpen('editColabInfo') && (
                    <ModalEditInfo
                        info={ data }
                        fetchData={ fetchData }
                    />
                )
            }
        </>
    )
}

export default FormularioDados;